import { RosterSearchFilters } from '__generated__/graphql'
import { RosterFilterState } from './rosterFilterState'

const ids = <T>(a: T[]): T[] | undefined => (a.length > 0 ? a : undefined)

const dateRange = (gte: string | undefined, lte: string | undefined) => {
    const g = gte ? new Date(gte).toISOString() : undefined
    const l = lte ? new Date(lte).toISOString() : undefined
    return g || l ? { gte: g, lte: l } : undefined
}

export const toGraphQLRosterFilters = (
    state: RosterFilterState
): RosterSearchFilters => ({
    name: state.name,
    quickSearch: state.quickSearch,
    companyIds: ids(state.companyIds),
    statuses: ids(state.statuses),
    type: state.type,
    createdByUserIds: ids(state.createdByUserIds),
    createdAtRange: dateRange(state.createdAtGte, state.createdAtLte),
    internalUserIds: ids(state.internalUserIds),
    industryIds: ids(state.industryIds),
    sectorIds: ids(state.sectorIds),
    geoLocationIds: ids(state.geoLocationIds),
    geoLocationText: ids(state.geoLocationText),
    titleIds: ids(state.titleIds),
    consultants:
        state.consultants === 'yes'
            ? true
            : state.consultants === 'no'
              ? false
              : undefined,
    fundSizeIds: ids(state.fundSizeIds),
    visaStatusIds: ids(state.visaStatusIds),
    startDates: ids(state.startDates),
    processStatusFilter:
        state.processStatusIds.length > 0 ||
        state.processStatusGroupIds.length > 0
            ? {
                  statusIds: ids(state.processStatusIds),
                  groupIds: ids(state.processStatusGroupIds),
              }
            : undefined,
})
